<template>
  <v-dialog v-model="dialogProcess" persistent max-width="800">
    <v-card class="pa-2">
      <v-form ref="form" lazy-validation>
        <v-card-title class="headline my-2">
          <span
            class="font-weight-bold text-body-2 text-sm-h6 text-md-h5"
            v-html="
              $t('cap_ord_detail_process_from', {
                value: orderDetail.customer.phone
              })
            "
          >
          </span>
        </v-card-title>
        <v-card-subtitle>
          <div class="text-body-2 text-md-body-1 grey--text">
            {{ $t('title_ord_detail_card') }}
          </div>
          <v-icon class="primary--text mr-2">mdi-cash-minus</v-icon>
          <span class="black--text text-body-2 text-md-body-1"
            >{{ orderDetail.payment.method }} ({{
              orderDetail.delivery.mode | toTitleCase
            }})</span
          >
        </v-card-subtitle>
        <v-card-text class="mt-n2">
          <v-row no-gutters>
            <v-col cols="12" xs="12" sm="8">
              <v-row dense>
                <v-col sm="6" class="d-flex justify-center">
                  <span>{{ $t('cap_ord_detail_name') }}</span>
                </v-col>
                <v-col sm="2">
                  <span>{{ $t('cap_ord_detail_quantity') }}</span>
                </v-col>
                <v-col sm="2">
                  <span>{{ $t('cap_ord_detail_price') }}</span>
                </v-col>
                <v-col sm="2">
                  <span>{{ $t('cap_ord_detail_total') }}</span>
                </v-col>
              </v-row>
              <v-row class="mt-n4">
                <v-col cols="12">
                  <v-list
                    max-height="250"
                    class="overflow-y-auto lighten-3 group-item px-2"
                  >
                    <v-row
                      v-for="item in orderDetail.cart"
                      :key="item.id"
                      no-gutters
                      class="mt-1 align-center"
                    >
                      <v-col sm="6">
                        <v-row no-gutters class="align-center">
                          <!--                                <v-col cols="12" sm="2">-->
                          <!--                                  <v-avatar tile :size="$vuetify.breakpoint.mdAndUp? '40' : '30'">-->
                          <!--                                    <v-img :src="image(item.name)" />-->
                          <!--                                  </v-avatar>-->
                          <!--                                </v-col>-->
                          <v-col cols="12" sm="10" class="px-sm-1 px-md-2">
                            {{ formatMulti(item.name) }}
                            <span v-if="item.measureUnit !== 'unit'">
                              ({{ formatMulti(item.measureUnit) }})
                            </span>
                            <span v-if="item.subProduct" class="caption">
                              +
                              {{ formatMulti(item.subProduct.name) }}</span
                            >
                            <!--                                    <span v-if="item.subProduct && item.subProduct.measureUnit !== 'Default'"> ({{ formatMulti(item.subProduct.measureUnit) }}) </span>-->
                            <span
                              v-if="item.discount && item.discount.percentage"
                              class="red--text caption"
                            >
                              ( {{ $t('cap_label_discount') }}
                              {{ item.discount.percentage }}%)</span
                            >
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col sm="2">
                        <span>{{ item.quantity | quantityFormat }}</span>
                      </v-col>
                      <v-col sm="2">
                        <span v-if="item.subProduct">
                          <span v-if="item.discountPrice">
                            $
                            {{ +item.price + +item.subProduct.price }}
                            {{ ' -> ' }}
                          </span>
                          $
                          {{
                            (item.discountPrice
                              ? +item.discountPrice + +item.subProduct.price
                              : +item.price + +item.subProduct.price)
                              | numberFormat
                          }}
                        </span>
                        <span v-else>
                          <span v-if="item.discountPrice">
                            <span> $ {{ item.price }} </span>
                            {{ ' -> ' }}
                          </span>
                          $
                          {{
                            (item.discountPrice
                              ? item.discountPrice
                              : item.price) | numberFormat
                          }}
                        </span>
                      </v-col>
                      <v-col sm="2">
                        <span v-if="item.subProduct"
                          >$
                          {{
                            (item.discountPrice
                              ? (+item.discountPrice + +item.subProduct.price) *
                                +item.quantity
                              : (+item.price + +item.subProduct.price) *
                                +item.quantity) | numberFormat
                          }}</span
                        >
                        <span v-else
                          >$
                          {{
                            (item.discountPrice
                              ? +item.discountPrice * +item.quantity
                              : +item.price * +item.quantity) | numberFormat
                          }}</span
                        >
                      </v-col>
                    </v-row>
                  </v-list>
                </v-col>
              </v-row>
              <v-row class="d-flex justify-end" no-gutters>
                <v-col cols="5" class="mt-n3 pt-0">
                  <v-row>
                    <v-col align="end">
                      <div v-if="orderDetail.subTotal" class="caption">
                        {{ $t('cap_ord_detail_sub_total') }}:
                      </div>
                      <div v-if="orderDetail.vat" class="caption">
                        {{ $t('cap_txt_vad') }}:
                      </div>
                      <div class="primary--text font-weight-bold">
                        {{ $t('cap_ord_detail_total') }}:
                      </div>
                    </v-col>
                    <v-col>
                      <div v-if="orderDetail.subTotal">
                        $ {{ orderDetail.subTotal | numberFormat }}
                      </div>
                      <div v-if="orderDetail.vat">
                        $ {{ orderDetail.vat | numberFormat }}
                      </div>
                      <div class="font-weight-bold">
                        $ {{ orderDetail.total | numberFormat }}
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" xs="12" sm="4">
              <v-row>
                <v-col sm="2">
                  <v-divider vertical color="#888"></v-divider>
                </v-col>
                <v-col sm="10" class="ml-n8">
                  <v-row align="center" class="mt-n3">
                    <v-col sm="3">
                      <v-icon large class="blue--text"
                        >mdi-facebook-messenger</v-icon
                      >
                    </v-col>
                    <v-col sm="9" class="ml-n3">
                      <span class="black--text">{{
                        orderDetail.customer.name
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row align="center" class="mt-n3">
                    <v-col sm="3">
                      <v-icon class="grey--text">mdi-phone</v-icon>
                    </v-col>
                    <v-col sm="9" class="ml-n3">
                      <span class="black--text">{{
                        orderDetail.customer.phone
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      orderDetail.customer.hasOwnProperty('location') &&
                      orderDetail.customer.location.hasOwnProperty('address') &&
                      orderDetail.customer.location.address
                    "
                    align="start"
                    class="mt-n3"
                  >
                    <v-col sm="2">
                      <v-icon class="grey--text">mdi-map-marker</v-icon>
                    </v-col>
                    <v-col sm="9" class="ml-n3">
                      <span class="black--text">{{
                        orderDetail.customer.location.address
                      }}</span>
                      <v-col
                        v-if="
                          orderDetail.customer.hasOwnProperty('location') &&
                          orderDetail.customer.location.hasOwnProperty(
                            'cord'
                          ) &&
                          orderDetail.delivery.mode == 'delivery'
                        "
                      >
                        <v-row>
                          <CassQRcode :document-id="documentId"></CassQRcode>
                          <CassMapping :document-id="documentId"></CassMapping>
                        </v-row>
                      </v-col>
                    </v-col>
                  </v-row>
                  <v-row align="center" class="mt-n3">
                    <v-col sm="3">
                      <v-icon class="grey--text"
                        >mdi-square-edit-outline</v-icon
                      >
                    </v-col>
                    <v-col sm="9" class="ml-n3">
                      <span class="grey--text font-italic">{{
                        noteFormat(orderDetail.customer.note)
                      }}</span>
                    </v-col>
                  </v-row>

                  <v-row
                    v-if="
                      orderDetail.payment.method == 'Cash' &&
                      orderDetail.payment.hasOwnProperty('cash') &&
                      orderDetail.delivery.mode == 'delivery'
                    "
                    align="center"
                    class="mt-n3"
                  >
                    <v-col sm="3">
                      <v-icon class="grey--text">mdi-cash-minus</v-icon>
                    </v-col>
                    <v-col sm="9" class="ml-n3">
                      <span class="grey--text font-italic">{{
                        noteFormat(orderDetail.payment.cash)
                      }}</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row
            v-if="orderDetail.delivery.mode.toLowerCase() !== 'pickup'"
            no-gutters
          >
            <v-col cols="12">
              <v-row no-gutters>
                <span class="text-body-1">{{
                  $t('cap_ord_detail_select_delivery_option')
                }}</span>
                <v-col cols="4">
                  <v-select
                    v-model="agent"
                    :items="deliveryAgents"
                    :label="$t('cap_order_detail_choose_delivery')"
                  ></v-select>
                </v-col>
                <v-col cols="4" class="pl-5">
                  <v-text-field
                    v-model="fee"
                    :label="$t('cap_delivery_fee')"
                    prefix="$"
                    :rules="deliveryFee"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <CassNewDeliveryAgents />
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="cancel(documentId)">{{
            $t('btn_txt_cancel')
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            width="100"
            @click="confirm(documentId, agent)"
            >{{ $t('btn_txt_accept') }}</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import CassNewDeliveryAgents from '../dialogs/CassNewDeliveryAgents'
import CassQRcode from './CassQRcode'
import CassMapping from './CassMapping'
export default {
  components: {
    CassMapping,
    CassQRcode,
    CassNewDeliveryAgents
  },
  filters: {
    numberFormat(data) {
      return (Math.round(data * 100) / 100).toFixed(2)
    },
    toTitleCase(str) {
      return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase()
    },
    quantityFormat(data) {
      return data > 9 ? data : '0' + data
    }
  },
  props: {
    locale: {
      type: String,
      default: 'en'
    },
    documentId: {
      type: String,
      default: 'EhE7o1faLNMEu0GOPevu'
    },
    dialogProcess: {
      type: Boolean
    }
  },
  data() {
    return {
      agent: '',
      fee: ''
    }
  },
  computed: {
    orderDetail() {
      if (this.documentId) {
        return this.$store.getters['order/orderAfterFilter'].filter(
          (order) => order.documentId === this.documentId
        )[0]
      } else {
        return this.$store.state.order.sample[0]
      }
    },
    deliveryAgents() {
      return this.$store.state.deliveryAgent.deliveryAgents.map((agent) => {
        return agent.name
      })
    },
    deliveryFee() {
      return [
        // (v) =>
        //   (!isNaN(parseFloat(v)) && v > 0) || 'Price must be bigger than 10'
        (v) => v >= 0 || this.$t('cap_form_price_invalid')
      ]
    }
  },
  methods: {
    /**
     * @func
     * @desc Change the status of component to previous status.
     * Change from `processing` to `newOrder` then close dialog.
     * @param documentId
     */
    cancel(documentId) {
      const payload = { documentId, status: 'newOrder' }
      this.$store.dispatch('order/changeLocalStatus', payload)
      const value = { dialogProcess: false, dialogDone: false }
      this.$refs.form.reset()
      this.$emit('changeDialog', value)
    },
    /**
     * @func
     * @desc close the processingDialog by call $event to parent `processCardList.vue`
     */
    confirm(documentId, name) {
      if (this.$refs.form.validate()) {
        const phone = this.deliveryPhone(name)
        const payload = {
          documentId,
          delivery: { name, phone, fee: (this.fee = parseFloat(this.fee)) }
        }
        this.$store.dispatch('order/processOrder', payload)
        this.agent = ''
        const value = { dialogProcess: false, dialogDone: false }
        this.$emit('changeDialog', value)
      }
    },
    // image (value) {
    //   let image = ''
    //   this.$store.getters['product/productAfterFilter'].forEach(product => {
    //     if (product.name === value) {
    //       image = product.image
    //     }
    //   })
    //   return image
    // },
    deliveryPhone(name) {
      let phone = ''
      this.$store.state.deliveryAgent.deliveryAgents.forEach((agent) => {
        if (agent.name === name) {
          phone = agent.phone
        }
      })
      return phone
    },
    formatMulti(value) {
      if (typeof value === 'object') {
        if (Object.prototype.hasOwnProperty.call(value, this.locale)) {
          return value[this.locale]
        } else {
          return value.en
        }
      } else {
        return value
      }
    },
    noteFormat(data) {
      return data || this.$t('cap_no_note')
    }
  }
}
</script>

<style scoped></style>
